import { Component, Input, OnInit } from '@angular/core';
import {
  BaseCoreState,
  baseDocumentSelectors,
  CustomerInquiryOfferListItemResponse,
  CustomerOfferResponse,
  DocumentCategoryResponse,
  DocumentListItemResponse,
} from 'base';
import { filter, map, take } from 'rxjs/operators';
import { Store } from '@ngrx/store';

@Component({
  selector: 'base-customer-offer-documents-tab',
  templateUrl: 'base-customer-offer-documents-tab.component.html',
})
export class BaseCustomerOfferDocumentsTabComponent implements OnInit {
  @Input() offer: (CustomerInquiryOfferListItemResponse & { order?: number }) | CustomerOfferResponse;
  documentList: Array<DocumentListItemResponse & { categoryLabel: string }> = [];

  constructor(private store: Store<BaseCoreState>) {}

  ngOnInit() {
    this.addDocumentCategories();
  }

  private addDocumentCategories() {
    this.store
      .select(baseDocumentSelectors.getDocumentCategories)
      .pipe(
        filter((documentCategoriesState) => !!documentCategoriesState.ok),
        take(1),
        map((documentCategoriesState: any) => documentCategoriesState.data)
      )
      .subscribe((documentCategories) => {
        if (documentCategories && this.offer.documents) {
          documentCategories = Object.entries(documentCategories as DocumentCategoryResponse).reduce(
            (collector, item) => {
              collector.push({ label: item[1] as string, value: +item[0] });

              return collector;
            },
            [] as { label: string; value: number }[]
          );
          this.documentList = this.offer.documents.map((document: any) => {
            return {
              ...document,
              categoryLabel: documentCategories.find(
                (category: { label: string; value: number }) => category.value === document.category
              )?.label,
            };
          });
        }
      });
  }
}
